export function properCase(text) {
  if (text === null) {
    return null;
  }
  return text
    .split("_")
    .map(str => str.charAt(0).toUpperCase() + str.slice(1))
    .join(" ");
}

export function properCaseField(text) {
  if (text === null) {
    return null;
  }

  if (text === "srp_condition") return "SRP Condition";
  return properCase(text);
}

export function spaceBetweenCaps(text) {
  if (text === null) return null;

  return text.replace(/([A-Z])/g, " $1");
}

export function getInitials(name) {
  if (name === null) {
    return null;
  }

  return name
    .split(" ")
    .map(str => str.charAt(0).toUpperCase())
    .join("");
}

export function getFirstNameLastInitial(name) {
  if (!name) {
    return null;
  }

  const nameArray = name.split(" ");
  nameArray[1] = nameArray[1].charAt(0).toUpperCase();

  return nameArray.join(" ");
}

export function truncate(text, targetLength, truncText = "...") {
  if (!text && text !== 0) {
    return null;
  }
  if (text.toString().length > targetLength) {
    return `${text.toString().substring(0, targetLength - 1)}${truncText}`;
  }
  return text;
}

export function toSentence(arr, divider = "and") {
  return arr
    .reduce(
      (prev, curr, i) =>
        prev + curr + (i === arr.length - 2 ? ` ${divider} ` : ", "),
      ""
    )
    .slice(0, -2);
}



// WEBPACK FOOTER //
// ./app/lib/formatters/text.js